import { render, staticRenderFns } from "./KantorCabang.vue?vue&type=template&id=34b0258c"
import script from "./KantorCabang.vue?vue&type=script&lang=js"
export * from "./KantorCabang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports